<div class="mat-elevation-z8">
  <table mat-table class="full-width-table" matSort aria-label="Elements">
    <!-- Name Column -->
    @for (c of displayedColumnsConfig; track c) {
      <ng-container [matColumnDef]="c.name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header
          [hidden]="c.hidden"  [class]="(!c.hidden ? 'visible-column' : '')">{{ (c.label ? c.label : c.name) | translate | ucFirst }}
        </th>
        <td mat-cell *matCellDef="let item" [hidden]="c.hidden" [class]="(!c.hidden ? 'visible-column' : '')">
          <span>
            @switch (c.type) {
              @case ('date') {
                <span>@if (item[c.name]) {
                  <span
                  >{{ item[c.name] }}</span>
                }</span>
              }
              @case ('link') {
                <span>
                  @if (item[c.name]) {
                    <span>
                      <a class='receipt_link' (click)="(c.name !== 'check' && item.receipt ? rowClick(item.receipt) : '')">{{ 'download_receipt' | translate| ucFirst }}</a>
                    </span>
                  }
                </span>
              }
              @case ('amount') {
                <span>
                  @if (item[c.name]) {
<span [ngClass]="(item.debit && item.total && item.total.total >= 0 ? 'debit' :
            'credit')">
                      {{ (item.credit ? '- ' : '') }}{{ item[c.name] | localizedCurrency }}
                    </span>
                  }
                  @if (!item[c.name]) {
                    <span>-</span>
                  }
                </span>
              }
              @default {
                <span>
                  @if (item[c.name]) {
                    <span>{{ item[c.name] | translate | ucFirst }}</span>
                  }
                  @if (!item[c.name]) {
                    <span>-</span>
                  }
                </span>
              }
            }
          </span>
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns; let key"
      (click)="(displayedColumnsConfig[key] && displayedColumnsConfig[key].noRowClick ? false : rowClick(row.id))"
    [class]="(displayedColumnsConfig[key] && displayedColumnsConfig[key].noRowClick ? '' : 'rowAction')"></tr>
  </table>

  <mat-paginator #paginator
    [length]="this.data.length"
    [pageIndex]="0"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 20]"
    aria-label="Select page">
  </mat-paginator>
</div>
